<template>
    <div class="card-desktop-container radius-12 p-lr-24">
        <div ref="cardBox" style="height: 100px">
            <div ref="cardBg" class="card-desktop-bg" :style="{ backgroundColor: ruleForm.primaryColors }"></div>
        </div>
        <div v-if="ruleForm.displayPicture != ''" class="add-img-container">
            <el-avatar class="company-logo" :size="48" :src="companyLogo" />
            <el-avatar class="display-picture" :size="128" :src="displayPicture" />
        </div>
        <p class="font-24 w-600 m-t-32 m-b-10">{{ ruleForm.fullName == '' ? 'Full Name' : ruleForm.fullName }}</p>
        <el-row>
            <el-col v-if="ruleForm.department != '' || ruleForm.jobTitle != ''" :span="12" class="p-r-10">
                <el-row gutter="10">
                    <el-col :span="12">
                        <div class="font-12 w-600 text-666 break-word">{{ ruleForm.department }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="font-12 w-600 text-666 break-word">{{ ruleForm.jobTitle }}</div>
                    </el-col>
                </el-row>
            </el-col>
            <el-col class="company-info" :span="ruleForm.department == '' && ruleForm.jobTitle == '' ? 24 : 12" :style="{ borderLeft: ruleForm.department != '' || ruleForm.jobTitle != '' ? '2px solid #ccc' : 'none', display: warning ? 'flex' : '' }">
                <div class="font-13 w-600 text-666 break-word">{{ ruleForm.companyName == '' ? 'Company Name' : ruleForm.companyName }}</div>
                <el-popover v-if="warning" class="box-item" placement="top-start" width="200" effect="dark">
                    <template #default>Organization Unverified.</template>
                    <template #reference>
                        <el-icon color="#DC5034" class="m-l-5">
                            <Warning />
                        </el-icon>
                    </template>
                </el-popover>
            </el-col>
        </el-row>
        <p v-if="warning && ruleForm.blurb != ''" class="font-12 text-666 m-t-8 m-b-0">
            {{ ruleForm.blurb }}
        </p>
        <div class="save-btn font-16 m-tb-32" :style="{ backgroundColor: ruleForm.primaryColors }">Save to Contacts</div>

        <div class="">
                  <el-row class="card-formList ">
            <el-col :span="3">
                <div class="card-formList-icon" :style="{ backgroundColor: ruleForm.primaryColors }">
                    <img src="@/assets/icon-email.png" alt="" />
                </div>
            </el-col>
            <el-col :span="20" class="card-formList-text font-13">{{ cardData.emailAddress == '' ? 'Email' : cardData.emailAddress }}</el-col>
        </el-row>
        <el-row class="card-formList" v-if="cardData.mobileNumber != ''">
            <el-col :span="3">
                <div class="card-formList-icon" :style="{ backgroundColor: ruleForm.primaryColors }">
                    <img src="@/assets/icon-phone.png" alt="" />
                </div>
            </el-col>
            <el-col :span="20" class="card-formList-text font-13">{{ cardData.mobileNumber }}</el-col>
        </el-row>
        <el-row class="card-formList" v-if="cardData.website != ''">
            <el-col :span="3">
                <div class="card-formList-icon" :style="{ backgroundColor: ruleForm.primaryColors }">
                    <img src="@/assets/icon-web.png" alt="" />
                </div>
            </el-col>
            <el-col :span="20" class="card-formList-text font-13">{{ cardData.website }}</el-col>
        </el-row>
        <el-row class="card-formList" v-if="cardData.customisableLink != ''">
            <el-col :span="3">
                <div class="card-formList-icon" :style="{ backgroundColor: ruleForm.primaryColors }">
                    <img src="@/assets/icon-link.png" alt="" />
                </div>
            </el-col>
            <el-col :span="20" class="card-formList-text font-13">{{ cardData.customisableLink }}</el-col>
        </el-row>
        <el-row class="card-formList" v-if="cardData.accreditations != ''">
            <el-col :span="3">
                <div class="card-formList-icon" :style="{ backgroundColor: ruleForm.primaryColors }">
                    <img src="@/assets/icon-qualification.png" alt="" />
                </div>
            </el-col>
            <el-col :span="20" class="card-formList-text font-13">{{ cardData.accreditations }}</el-col>
        </el-row>
        <el-row class="card-formList" v-if="cardData.companyAddress != ''">
            <el-col :span="3">
                <div class="card-formList-icon" :style="{ backgroundColor: ruleForm.primaryColors }">
                    <img src="@/assets/icon-map.png" alt="" />
                </div>
            </el-col>
            <el-col :span="20" class="card-formList-text font-13">{{ cardData.companyAddress }}</el-col>
        </el-row>
        <el-row class="card-formList" v-if="cardData.wechat != ''">
            <el-col :span="3">
                <div class="card-formList-icon" :style="{ backgroundColor: ruleForm.primaryColors }">
                    <img src="@/assets/icon-wechat.png" alt="" />
                </div>
            </el-col>
            <el-col :span="20" class="card-formList-text font-13">{{ cardData.wechat }}</el-col>
        </el-row>
        <el-row class="card-formList" v-if="cardData.whatsapp != ''">
            <el-col :span="3">
                <div class="card-formList-icon" :style="{ backgroundColor: ruleForm.primaryColors }">
                    <img src="@/assets/icon-whatsapp.png" alt="" />
                </div>
            </el-col>
            <el-col :span="20" class="card-formList-text font-13">{{ cardData.whatsapp }}</el-col>
        </el-row>
        <el-row class="card-formList" v-if="cardData.linkedin != ''">
            <el-col :span="3">
                <div class="card-formList-icon" :style="{ backgroundColor: ruleForm.primaryColors }">
                    <img src="@/assets/icon-in.png" alt="" />
                </div>
            </el-col>
            <el-col :span="20" class="card-formList-text font-13">{{ cardData.linkedin }}</el-col>
        </el-row>
        <el-row class="card-formList" v-if="cardData.instagram != ''">
            <el-col :span="3">
                <div class="card-formList-icon" :style="{ backgroundColor: ruleForm.primaryColors }">
                    <img src="@/assets/icon-Instagram.png" alt="" />
                </div>
            </el-col>
            <el-col :span="20" class="card-formList-text font-13">{{ cardData.instagram }}</el-col>
        </el-row>
        <el-row class="card-formList" v-if="cardData.xProfile != ''">
            <el-col :span="3">
                <div class="card-formList-icon" :style="{ backgroundColor: ruleForm.primaryColors }">
                    <img src="@/assets/icon-X.png" alt="" />
                </div>
            </el-col>
            <el-col :span="20" class="card-formList-text font-13">{{ cardData.xProfile }}</el-col>
        </el-row>
        <el-row class="card-formList" v-if="cardData.facebook != ''">
            <el-col :span="3">
                <div class="card-formList-icon" :style="{ backgroundColor: ruleForm.primaryColors }">
                    <img src="@/assets/icon-facebook.png" alt="" />
                </div>
            </el-col>
            <el-col :span="20" class="card-formList-text font-13">{{ cardData.facebook }}</el-col>
        </el-row>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted, watch } from 'vue';

const props = defineProps(['ruleForm', 'warning']);
const companyLogo = ref('');
const displayPicture = ref('');
let cardData = ref(JSON.parse(JSON.stringify(props.ruleForm)));

watch(
    () => props.ruleForm,
    newVal => {
        cardData.value = newVal;
        companyLogo.value = process.env.VUE_APP_BASE_API + '/api/v1/file?id=' + cardData.value.companyLogo;
        displayPicture.value = process.env.VUE_APP_BASE_API + '/api/v1/file?id=' + cardData.value.displayPicture;
    },
    { deep: true }
);

const cardBg = ref(null);
const cardBox = ref(null);

onMounted(() => {
    if (cardBg.value) {
        cardBox.value.style.height = `${cardBg.value.height}px`;
    }
});
</script>
<style lang="scss" scoped>
.card-desktop-container {
    position: relative;
    // width: 300px;
    background-color: #fff;
    border-radius: 12px;
    padding-bottom: 10px;
    text-align: center;
    .card-desktop-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        border-radius: 12px 12px 0 0;
        object-fit: cover;
        height: 100px;
        clip-path: path('M0,0 L0,70 C250,156 165,25 364,85 L500,0 Z');
    }

    .company-info {
        // display: flex;
        align-items: center;
        padding: 0 10px;
    }

    .add-img-container {
        position: relative;
        top: -75px;
        height: 60px;
        .company-logo,
        .display-picture {
            position: absolute;
        }

        .company-logo {
            z-index: 99;
            bottom: -124%;
            left: 53%;
        }

        .display-picture {
            top: 10%;
            left: 50%;
            transform: translateX(-50%);
            z-index: 88;
        }
    }

    .save-btn {
        display: inline-block;
        border-radius: 6px;
        padding: 11px 36px;
        color: #fff;
    }

    .card-formList {
        margin-bottom: 15px;
        .card-formList-icon {
            position: relative;
            width: 25px;
            height: 25px;
            border-radius: 50%;
            img {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                max-width: 13px;
                max-height: 13px;
            }
        }

        .card-formList-text {
            display: flex;
            align-items: center;
        }
    }
}
</style>
